(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oimano-atc"] && !Shopify.designMode) return;
  try {
    class OimanoAtc extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-oi-atc-price]');
      this.form = this.closest('form');
      if (!this.form) return;

      this.form.addEventListener('oi:total-change', (e) => {
        if (!this.priceEl) return;
        const { totalMoney } = e.detail || {};
        if (totalMoney) this.priceEl.innerHTML = '&nbsp;&middot; ' + totalMoney;
      });
    }
  }

  if (!customElements.get('oimano-atc')) {
    customElements.define('oimano-atc', OimanoAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-cross-sell"] && !Shopify.designMode) return;
  try {
    class OimanoCrossSell extends HTMLElement {
    connectedCallback() {
      this.vrh = this.querySelector('[data-oi-xs-vrh]');
      this.sadrzaj = this.querySelector('[data-oi-xs-sadrzaj]');
      this.greskaEl = this.querySelector('[data-oi-xs-greska]');
      this.statusEl = this.querySelector('[data-oi-xs-status]');
      this.dijagEl = this.querySelector('[data-oi-xs-dijag]');
      this.izKolekcije = this.dataset.izKolekcije === 'true';
      this.designMode = this.dataset.designMode === 'true';
      // Dijagnostika: u editoru teme, ili na bilo kom linku sa `oi_dijag`.
      this.dijagVidljiv = this.designMode || window.location.search.indexOf('oi_dijag') > -1;

      // Klik, ne `submit`: kartica NEMA svoju formu (blok stoji unutar forme
      // proizvoda, a forma u formi nije dozvoljena — vidi komentar na početku).
      this.addEventListener('click', (e) => {
        const dugme = e.target.closest('[data-oi-xs-dodaj]');
        if (!dugme || dugme.disabled) return;
        const forma = dugme.closest('[data-oi-xs-forma]');
        if (!forma) return;
        e.preventDefault();
        this.dodaj(forma);
      });

      if (this.izKolekcije) {
        // Kolekcija je već iscrtana na serveru — nema čekanja ni zahteva.
        this.pokreni();
      } else if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (u) => {
            if (u.some((x) => x.isIntersecting)) {
              this.io.disconnect();
              this.ucitaj();
            }
          },
          { rootMargin: '400px' }
        );
        this.io.observe(this);
      } else {
        this.ucitaj();
      }
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.traka?.ugasi();
    }

    pokreni() {
      if (!this.querySelector('[data-oi-xs-traka]')) return this.dijagnostika('nema trake');
      this.vrh.hidden = false;
      if (!window.OimanoTraka) return this.dijagnostika('OimanoTraka nije učitana');
      this.traka = new window.OimanoTraka(this);
      this.dijagnostika();
      // Posle prvog koraka stanje se menja, pa osvežimo prikaz.
      setTimeout(() => this.dijagnostika(), 1200);
    }

    // Kratak izveštaj: odmah se vidi šta blokira smenu, bez konzole.
    dijagnostika(greska) {
      if (!this.dijagEl || !this.dijagVidljiv) return;
      this.dijagEl.hidden = false;
      if (greska) {
        this.dijagEl.textContent = 'Greška: ' + greska;
        return;
      }
      const t = this.traka;
      const lista = this.querySelector('[data-oi-xs-traka]');
      const izvor = this.izKolekcije
        ? 'kolekcija (' + (this.dataset.brojUKolekciji || '?') + ' u njoj)'
        : 'Search & Discovery';
      const delovi = [
        'izvor: ' + izvor,
        'kartica: ' + (lista ? lista.children.length : 0),
        'krug: ' + (t && t.krugRadi ? 'da' : 'ne'),
        'preliv: ' + (lista && lista.scrollWidth > lista.clientWidth + 4 ? 'da' : 'NE'),
        'smena: ' + (t && t.smenaUkljucena ? 'da' : 'NE'),
        'pauza: ' + this.dataset.pauza + 's',
        'smanjene animacije: ' + (t && t.mqManje && t.mqManje.matches ? 'UKLJUČENE' : 'ne'),
        'gase smenu: ' + (t && t.smanjeneGase && t.smanjeneGase() ? 'DA' : 'ne'),
        'sada radi: ' + (t && t.smePomerati && t.smePomerati() ? 'da' : 'NE'),
        'širina: ' + Math.round(this.getBoundingClientRect().width) + 'px',
      ];
      this.dijagEl.textContent = delovi.join(' · ');
    }

    async ucitaj() {
      if (this.ucitano) return;
      this.ucitano = true;
      try {
        const odgovor = await fetch(this.dataset.url);
        if (!odgovor.ok) throw new Error(odgovor.status);
        const tekst = await odgovor.text();
        const lista = new DOMParser().parseFromString(tekst, 'text/html').querySelector('.oi-xs__lista');
        if (!lista || lista.children.length === 0) {
          this.prazno();
          return;
        }
        this.sadrzaj.innerHTML = '';
        this.sadrzaj.appendChild(lista);
        this.pokreni();
      } catch (e) {
        this.dijagnostika('predlozi se nisu učitali (' + e.message + ')');
      }
    }

    prazno() {
      if (!this.designMode) return;
      this.sadrzaj.innerHTML =
        '<p class="oi-xs__dev"><strong>Nema šta da se predloži.</strong><br>' +
        'Najlakše: u podešavanjima ovog bloka izaberite <em>Kolekciju</em> ' +
        '(npr. „Oimano Upsell“). Svi proizvodi iz nje se predlažu, na svim ' +
        'stranicama odjednom.<br>Druga mogućnost: Shopify admin → Apps → ' +
        'Search &amp; Discovery → Recommendations.</p>';
      this.vrh.hidden = false;
    }

    async dodaj(forma) {
      const karta = forma.closest('.oi-xs__karta');
      const select = karta?.querySelector('.oi-xs__select');
      const id = select ? select.value : forma.dataset.oiXsJednaVarijanta;
      if (!id || id === 'false') return;

      // Dok se dodaje, smena staje — da kartica ne odlebdi ispod prsta.
      this.traka?.nastaviKasnije(4000);

      karta?.classList.add('is-radi');
      this.greskaEl.hidden = true;

      const cilj = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sekcije = [];
      if (cilj && typeof cilj.getSectionsToRender === 'function') {
        cilj.getSectionsToRender().forEach((s) => sekcije.push(s.id));
      }
      if (!sekcije.includes('cart-icon-bubble')) sekcije.push('cart-icon-bubble');

      try {
        const odgovor = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(id), quantity: 1 }],
            sections: sekcije,
            sections_url: window.location.pathname,
          }),
        });
        const podaci = await odgovor.json();
        if (podaci.status) throw new Error(podaci.description || podaci.message);

        karta?.classList.remove('is-radi');
        // I original i svi njegovi klonovi dobijaju potvrdu.
        const pid = karta?.dataset.oiXsProizvod;
        if (pid) {
          this.querySelectorAll('.oi-xs__karta[data-oi-xs-proizvod="' + pid + '"]').forEach((k) => {
            k.classList.add('is-dodato');
            const t = k.querySelector('.oi-xs__dodaj-tekst');
            if (t) t.textContent = 'Dodato';
          });
        }
        if (this.statusEl) this.statusEl.textContent = 'Proizvod je dodat u korpu.';

        if (cilj && typeof cilj.renderContents === 'function') cilj.renderContents(podaci);
        else this.osveziKorpicu(podaci);

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oimano-cross-sell' });
          }
        } catch (e) {
          /* pubsub nije obavezan */
        }
      } catch (e) {
        karta?.classList.remove('is-radi');
        this.greskaEl.textContent = 'Nismo mogli da dodamo proizvod. Pokušajte ponovo.';
        this.greskaEl.hidden = false;
      }
    }

    osveziKorpicu(podaci) {
      const html = podaci.sections && podaci.sections['cart-icon-bubble'];
      if (!html) return;
      const novi = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      const stari = document.getElementById('shopify-section-cart-icon-bubble');
      if (novi && stari) stari.innerHTML = novi.innerHTML;
    }
  }

  if (!customElements.get('oimano-cross-sell')) {
    customElements.define('oimano-cross-sell', OimanoCrossSell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-google"] && !Shopify.designMode) return;
  try {
    // Strelice samo kliznu traku za jednu karticu. Prevlačenje prstom radi samo
  // od sebe, preko `overflow-x` i `scroll-snap`, bez ijedne linije koda.
  class OimanoGoogle extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('[data-oi-gg-traka]');
      if (!this.traka) return;

      const nazad = this.querySelector('[data-oi-gg-nazad]');
      const napred = this.querySelector('[data-oi-gg-napred]');

      const korak = () => {
        const karta = this.traka.querySelector('.oi-gg__karta');
        if (!karta) return 300;
        const razmak = parseFloat(getComputedStyle(this.traka).columnGap) || 0;
        return karta.getBoundingClientRect().width + razmak;
      };

      if (nazad) {
        nazad.addEventListener('click', () => {
          this.traka.scrollBy({ left: -korak(), behavior: 'smooth' });
        });
      }

      if (napred) {
        napred.addEventListener('click', () => {
          this.traka.scrollBy({ left: korak(), behavior: 'smooth' });
        });
      }

      const osvezi = () => {
        const kraj = this.traka.scrollWidth - this.traka.clientWidth - 2;
        if (nazad) nazad.disabled = this.traka.scrollLeft <= 2;
        if (napred) napred.disabled = this.traka.scrollLeft >= kraj;
      };

      this.traka.addEventListener('scroll', osvezi, { passive: true });
      window.addEventListener('resize', osvezi);
      osvezi();
    }
  }

  if (!customElements.get('oimano-google')) {
    customElements.define('oimano-google', OimanoGoogle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-klipovi"] && !Shopify.designMode) return;
  try {
    class OimanoKlipovi extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('.oi-kl__traka');
      const dugmad = [...this.querySelectorAll('button.oi-kl__dugme')];

      this.stavke = dugmad.map(function (b) {
        return { src: b.dataset.src, naslov: b.dataset.naslov || '' };
      });
      dugmad.forEach((b, i) => b.addEventListener('click', () => this.otvori(i)));

      this.nazad = this.querySelector('.oi-kl__strelica--nazad');
      this.napred = this.querySelector('.oi-kl__strelica--napred');
      this.vuceno = false;

      if (this.traka) {
        if (this.nazad && this.napred) {
          this.nazad.addEventListener('click', () => this.klizi(-1));
          this.napred.addEventListener('click', () => this.klizi(1));
        }
        this.traka.addEventListener('scroll', () => this.osvezi(), { passive: true });
        window.addEventListener('resize', () => this.osvezi(), { passive: true });
        this.vucenje();
        this.osvezi();
      }

      this.naTaster = (e) => {
        if (e.key === 'Escape') this.zatvori();
        if (e.key === 'ArrowRight') this.pomeri(1);
        if (e.key === 'ArrowLeft') this.pomeri(-1);
      };
    }

    // Povlačenje mišem. Na dodir ne diramo ništa — tamo je nativni skrol bolji
    // od bilo čega što bismo napisali (inercija, granice, odziv).
    //
    // KLJUČNO: `setPointerCapture` se poziva TEK kada pokazivač pređe 4px.
    // Dok je hvatanje aktivno, pretraživač preusmeri i `click` na element koji
    // je uhvatio pokazivač — dakle na traku, a ne na dugme klipa. Kad se to
    // radilo na svaki `pointerdown`, plejer se nije otvarao na klik.
    vucenje() {
      let aktivan = false;
      let x0 = 0;
      let s0 = 0;

      this.traka.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        aktivan = true;
        this.vuceno = false;
        x0 = e.clientX;
        s0 = this.traka.scrollLeft;
      });

      this.traka.addEventListener('pointermove', (e) => {
        if (!aktivan) return;
        const d = e.clientX - x0;
        // Sitno drhtanje miša pri kliku nije vučenje.
        if (!this.vuceno && Math.abs(d) < 4) return;

        if (!this.vuceno) {
          this.vuceno = true;
          this.classList.add('is-vuce');
          try { this.traka.setPointerCapture(e.pointerId); } catch (greska) {}
        }

        this.traka.scrollLeft = s0 - d;
        this.osvezi();
      });

      const kraj = () => {
        if (!aktivan) return;
        aktivan = false;
        // Klasa se sklanja odmah. Zastavica `vuceno` živi do `click`-a, koji
        // se ispaljuje neposredno posle `pointerup`.
        this.classList.remove('is-vuce');
      };

      this.traka.addEventListener('pointerup', kraj);
      this.traka.addEventListener('pointercancel', kraj);
      this.traka.addEventListener('dragstart', (e) => e.preventDefault());

      // Hvatamo u capture fazi, pre nego što dugme klipa odradi svoje.
      this.traka.addEventListener(
        'click',
        (e) => {
          if (!this.vuceno) return;
          e.preventDefault();
          e.stopPropagation();
          this.vuceno = false;
        },
        true
      );
    }

    klizi(smer) {
      const prva = this.traka.querySelector('.oi-kl__stavka');
      if (!prva) return;
      const korak = prva.getBoundingClientRect().width + 12;
      this.traka.scrollBy({ left: korak * smer });
    }

    // Bledi rub i strelice se pokazuju samo tamo gde stvarno ima još klipova.
    osvezi() {
      const t = this.traka;
      const visak = t.scrollWidth - t.clientWidth;
      const imaLevo = visak > 4 && t.scrollLeft > 4;
      const imaDesno = visak > 4 && t.scrollLeft < visak - 4;

      this.style.setProperty('--oi-kl-levo', imaLevo ? '2.6rem' : '0px');
      this.style.setProperty('--oi-kl-desno', imaDesno ? '2.6rem' : '0px');

      if (this.nazad) this.nazad.hidden = !imaLevo;
      if (this.napred) this.napred.hidden = !imaDesno;
    }

    otvori(i) {
      if (this.vuceno) return;
      if (this.pl) this.zatvori();
      this.i = i;

      // Klip kreće SA ZVUKOM (traženo 09.09.2026). Pregledači brane
      // puštanje sa zvukom samo kad ga niko nije zatražio; ovde ga otvara
      // klik kupca na sličicu, pa je dozvoljeno. Ako pregledač ipak odbije,
      // `pusti()` se tiho vraća na bez zvuka, da klip uvek krene.
      this.tih = false;

      const pl = document.createElement('div');
      pl.className = 'oi-kp';
      pl.setAttribute('role', 'dialog');
      pl.setAttribute('aria-modal', 'true');

      const vrh = document.createElement('div');
      vrh.className = 'oi-kp__vrh';

      const trake = document.createElement('div');
      trake.className = 'oi-kp__trake';
      this.puni = this.stavke.map(function () {
        const t = document.createElement('span');
        t.className = 'oi-kp__traka';
        const p = document.createElement('span');
        p.className = 'oi-kp__pun';
        t.appendChild(p);
        trake.appendChild(t);
        return p;
      });

      this.ton = document.createElement('button');
      this.ton.type = 'button';
      this.ton.className = 'oi-kp__akcija';
      this.ton.setAttribute('aria-label', 'Zvuk');
      this.ton.textContent = '🔊';
      this.ton.addEventListener('click', () => this.prebaciTon());

      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'oi-kp__akcija';
      x.setAttribute('aria-label', 'Zatvori');
      x.textContent = '✕';
      x.addEventListener('click', () => this.zatvori());

      vrh.append(trake, this.ton, x);

      const scena = document.createElement('div');
      scena.className = 'oi-kp__scena';

      this.video = document.createElement('video');
      this.video.className = 'oi-kp__video';
      this.video.playsInline = true;
      this.video.muted = true;
      this.video.preload = 'auto';
      this.video.addEventListener('ended', () => this.pomeri(1));

      this.opis = document.createElement('p');
      this.opis.className = 'oi-kp__opis';

      const zNazad = document.createElement('button');
      zNazad.type = 'button';
      zNazad.className = 'oi-kp__zona oi-kp__zona--nazad';
      zNazad.setAttribute('aria-label', 'Prethodni klip');
      zNazad.addEventListener('click', () => this.pomeri(-1));

      const zNapred = document.createElement('button');
      zNapred.type = 'button';
      zNapred.className = 'oi-kp__zona oi-kp__zona--napred';
      zNapred.setAttribute('aria-label', 'Sledeći klip');
      zNapred.addEventListener('click', () => this.pomeri(1));

      scena.append(this.video, this.opis, zNazad, zNapred);
      pl.append(vrh, scena);
      document.body.appendChild(pl);

      this.pl = pl;
      this.staroOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.naTaster);

      /* Pokreti prstom, kao u pričama na Instagramu (traženo 09.09.2026):
           · prevlačenje ULEVO   → sledeći klip
           · prevlačenje UDESNO  → prethodni klip
           · prevlačenje NADOLE  → izlaz iz plejera

         Osa se bira jednom, na prvih 8px, i posle se ne menja. Bez toga
         kosi pokret prsta naizmenično pomera klip i gasi plejer.

         Nadole plejer prati prst i bledi, da kupac vidi da izlazi pre nego
         što pusti prst. Ako ne prevuče dovoljno, vraća se na mesto.

         ZAMKA (pravilo 12): zone za prethodni i sledeći klip su dugmad.
         Posle pravog prevlačenja pregledač bi ipak opalio klik na zonu i
         klip bi preskočio dvaput. Zato se klik gasi u capture fazi, i to
         SAMO ako je prevlačenja stvarno bilo. */
      let px = null;
      let py = null;
      let osa = null;
      let vuceno = false;

      const vrati = () => {
        pl.style.transition = 'transform 0.22s ease, opacity 0.22s ease';
        pl.style.transform = '';
        pl.style.opacity = '';
      };

      scena.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        px = e.touches[0].clientX;
        py = e.touches[0].clientY;
        osa = null;
        vuceno = false;
        pl.style.transition = 'none';
      }, { passive: true });

      scena.addEventListener('touchmove', (e) => {
        if (px === null || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - px;
        const dy = e.touches[0].clientY - py;

        if (osa === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          osa = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
          vuceno = true;
        }

        if (osa === 'y' && dy > 0) {
          const deo = Math.min(1, dy / 320);
          pl.style.transform = 'translateY(' + dy + 'px) scale(' + (1 - deo * 0.08).toFixed(3) + ')';
          pl.style.opacity = (1 - deo * 0.55).toFixed(3);
        }
      }, { passive: true });

      scena.addEventListener('touchend', (e) => {
        if (px === null) return;
        const dx = e.changedTouches[0].clientX - px;
        const dy = e.changedTouches[0].clientY - py;
        const prag = Math.min(140, (window.innerHeight || 800) * 0.18);
        px = null;
        py = null;

        if (osa === 'y') {
          if (dy > prag) { this.zatvori(); } else { vrati(); }
        } else if (osa === 'x' && Math.abs(dx) > 50) {
          this.pomeri(dx < 0 ? 1 : -1);
        }
        osa = null;
      }, { passive: true });

      scena.addEventListener('touchcancel', () => { px = null; py = null; osa = null; vrati(); }, { passive: true });

      scena.addEventListener('click', (e) => {
        if (!vuceno) return;
        vuceno = false;
        e.stopPropagation();
        e.preventDefault();
      }, true);

      this.pusti();
      x.focus();
    }

    pusti() {
      const s = this.stavke[this.i];
      if (!s) return;

      this.puni.forEach((p, k) => { p.style.width = k < this.i ? '100%' : '0'; });

      this.video.src = s.src;
      this.video.muted = this.tih;
      this.opis.textContent = s.naslov;
      this.opis.hidden = !s.naslov;

      const igraj = this.video.play();
      if (igraj && igraj.catch) {
        igraj.catch(() => {
          // Pregledač je odbio puštanje sa zvukom. Ne ostavljamo kupca pred
          // crnim ekranom: gasimo zvuk, menjamo ikonu da stanje bude iskreno,
          // i puštamo ponovo.
          this.tih = true;
          this.video.muted = true;
          this.ton.textContent = '🔇';
          const opet = this.video.play();
          if (opet && opet.catch) opet.catch(function () {});
        });
      }

      cancelAnimationFrame(this.raf);
      const tik = () => {
        if (!this.pl) return;
        const d = this.video.duration;
        if (d && isFinite(d)) {
          this.puni[this.i].style.width = Math.min(100, (this.video.currentTime / d) * 100) + '%';
        }
        this.raf = requestAnimationFrame(tik);
      };
      this.raf = requestAnimationFrame(tik);
    }

    pomeri(k) {
      const s = this.i + k;
      if (s < 0) return;
      if (s >= this.stavke.length) { this.zatvori(); return; }
      this.i = s;
      this.pusti();
    }

    prebaciTon() {
      this.tih = !this.tih;
      this.video.muted = this.tih;
      this.ton.textContent = this.tih ? '🔇' : '🔊';
    }

    zatvori() {
      cancelAnimationFrame(this.raf);
      document.removeEventListener('keydown', this.naTaster);
      document.body.style.overflow = this.staroOverflow || '';
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.pl) {
        this.pl.remove();
        this.pl = null;
      }
    }

    disconnectedCallback() { this.zatvori(); }
  }

  if (!customElements.get('oimano-klipovi')) customElements.define('oimano-klipovi', OimanoKlipovi);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-otirac"] && !Shopify.designMode) return;
  try {
    // Mere prepisane iz TeeInBlue nacrta. Ne menjati napamet.
  // ── DIZAJNI ──────────────────────────────────────────────────────────────
  // Brojevi su prepisani iz TeeInBlue nacrta, nijedan nije izmišljen:
  //   PREZIME  → „Otirač Latinica" (1117888) i „Otirač Ćirilica" (1117889)
  //   IZUJ SE  → „Izuj se 1" (1117623)
  //
  // Položaj crteža IZUJ SE na otiraču nije mogao da se pročita iz njihove
  // baze, jer tu kampanju njihov MCP ne vidi. Izmeren je sa gotove slike
  // jedne prave porudžbine (07.10.2026): crtež zauzima 89,9 odsto širine
  // otirača i stoji tačno na njegovoj visinskoj sredini.
  const DIZAJNI = {
    prezime: {
      nacrt: { w: 7087, h: 4724 },
      polje: { left: 34, top: 175.74468085106383, w: 892, h: 595 },
      slojevi: [
        { slika: 'ornament', top: 887, left: 589, w: 5906, h: 1737 },
        { slika: 'strelice', top: 2887, left: 1277, w: 4530, h: 104 },
      ],
      pisma: {
        latinica: {
          font: 'OimanoGourmand',
          slojevi: [{ slika: 'porodica', top: 2807, left: 2648, w: 1784, h: 210 }],
          tekstovi: [
            { polje: 'inicijal', cx: 3542, cy: 1755.5, velicina: 1068.42, maxSirina: 1000 },
            { polje: 'prezime', cx: 3542, cy: 3549.15, velicina: 690.77, maxSirina: 5000 },
          ],
        },
        cirilica: {
          font: 'OimanoGaramond',
          slojevi: [{ slika: 'porodicaCir', top: 2810, left: 2510, w: 2062, h: 254 }],
          tekstovi: [
            { polje: 'inicijal', cx: 3556.38, cy: 1755.5, velicina: 1060.77, maxSirina: 992.84 },
            { polje: 'prezime', cx: 3542, cy: 3549.15, velicina: 690.77, maxSirina: 5000 },
          ],
        },
      },
    },
    izujse: {
      nacrt: { w: 1600, h: 1600 },
      polje: { left: 7.7, top: 30.6, w: 944.6, h: 944.6 },
      slojevi: [{ slika: 'izujse', top: 547.82, left: 110.85, w: 1376.49, h: 504.59 }],
      pisma: {
        latinica: {
          font: 'OimanoRubik',
          slojevi: [],
          tekstovi: [
            { polje: 'prezime', cx: 797.63, cy: 801.01, velicina: 323, maxSirina: 1350, razmak: 50 },
          ],
        },
      },
    },
  };

  // TeeInBlue svoj mokap opisuje u polju 960 × 960. SVI brojevi ispod su u
  // tom prostoru, pa i POLJE i ISECAK.
  //
  // ⚠ SAM FAJL NIJE 960 PIKSELA. `oimano-otirac-podloga.webp` je 1024 × 1024.
  // Ko bude crtao taj fajl mora prvo da preračuna iz prostora 960 u prave
  // piksele, inače se nacrta samo gornji levi deo slike i otirač deluje
  // uvećano i odsečeno. Tačno to se desilo 07.10.2026.
  const MOKAP = 960;

  // ⚠ CELA fotografija, zajedno sa natpisom „OVA FOTOGRAFIJA SLUŽI KAO
  // PRIMER!". Natpis je namerno tu, to je zvanična fotografija proizvoda sa
  // ogradom. Probali smo 07.10.2026 da je isečemo na sam otirač i Mihajlo je
  // tražio da se vrati. Ne isecati ponovo bez njegove reči.
  const ISECAK = { x: 0, y: 0, w: 960, h: 960 };

  const PLATNO = 1440;
  const SIRINA_OTIRACA = 1; // cela fotografija popunjava platno
  const SCENA = (function () {
    const w = PLATNO * SIRINA_OTIRACA;
    const h = (w / ISECAK.w) * ISECAK.h;
    return { x: (PLATNO - w) / 2, y: (PLATNO - h) / 2, w: w, h: h, k: w / ISECAK.w };
  })();
  // Latinica u ćirilicu. Dvoslovi idu PRVI, inače bi „LJ" postalo „ЛЈ".
  const DVOSLOVI = [['LJ', 'Љ'], ['NJ', 'Њ'], ['DŽ', 'Џ'], ['DJ', 'Ђ']];
  const SLOVA = {
    A: 'А', B: 'Б', V: 'В', G: 'Г', D: 'Д', Đ: 'Ђ', E: 'Е', Ž: 'Ж', Z: 'З',
    I: 'И', J: 'Ј', K: 'К', L: 'Л', M: 'М', N: 'Н', O: 'О', P: 'П', R: 'Р',
    S: 'С', T: 'Т', Ć: 'Ћ', U: 'У', F: 'Ф', H: 'Х', C: 'Ц', Č: 'Ч', Š: 'Ш',
  };

  function uCirilicu(tekst) {
    let t = String(tekst || '').toUpperCase();
    DVOSLOVI.forEach(([lat, cir]) => { t = t.split(lat).join(cir); });
    return t.split('').map((z) => (SLOVA[z] !== undefined ? SLOVA[z] : z)).join('');
  }
  // `cy` je SREDINA reda, ne vrh. Vidi se po tome što je sredina ornamenta
  // (887 + 1737/2 = 1755,5) tačno jednaka vrednosti koju TeeInBlue drži za
  // inicijal. Zato crtamo sa `textBaseline = 'middle'`.

  class OimanoOtirac extends HTMLElement {
    connectedCallback() {
      this.platno = this.querySelector('[data-oi-ot-platno]');
      this.ceka = this.querySelector('[data-oi-ot-ceka]');
      this.poljeInicijal = this.querySelector('[data-oi-ot-inicijal]');
      this.poljePrezime = this.querySelector('[data-oi-ot-prezime]');
      this.poljeSlika = this.querySelector('[data-oi-ot-slika]');
      if (!this.platno) return;

      this.ctx = this.platno.getContext('2d');
      this.dizajn = DIZAJNI[this.dataset.dizajn] || DIZAJNI.prezime;
      this.lukInicijal = Number(this.dataset.lukInicijal) || 0;
      this.lukPrezime = Number(this.dataset.lukPrezime) || 0;

      // Formu tražimo pre prvog crtanja, jer iz nje čitamo izabranu varijantu.
      this.forma = this.closest('form[action*="/cart/add"]');
      this.uGaleriju();

      this.pripremi().then(() => {
        if (this.ceka) this.ceka.hidden = true;
        this.prebroj();
        this.crtaj();
      });

      this.brojac = this.querySelector('[data-oi-ot-broj]');

      const osvezi = () => {
        this.prebroj();
        this.crtaj();
        this.proveri();
      };
      [this.poljeInicijal, this.poljePrezime].forEach((p) => {
        if (!p) return;
        p.addEventListener('input', () => {
          p.value = p.value.toUpperCase();
          this.zapamti();
          osvezi();
        });

        // Polje je obavezno. Poruka mora da bude naša, jer pregledač svoju
        // ispisuje na jeziku sistema, pa bi Srbinu sa engleskim Windows-om
        // pisalo „Please fill out this field".
        p.addEventListener('invalid', () => {
          p.setCustomValidity('Upišite tekst koji ide na otirač.');
        });
      });

      // ⚠ Promena pisma PONOVO UČITAVA stranicu, jer se menja varijanta.
      // Oslanjati se na to da pregledač sam vrati otkucani tekst ne valja:
      // ponekad ga vrati posle prvog crtanja, pa otirač ostane prazan,
      // a kupac vidi prazan krug iako u polju piše njegovo prezime.
      // Zato tekst pamtimo sami i vraćamo ga pre crtanja.
      this.vrati();

      // Promena pisma: naš birač varijanti javlja `shopify-event-variant-changed`,
      // a hvatamo i običnu promenu u formi, za slučaj da se birač promeni.
      document.addEventListener('shopify-event-variant-changed', osvezi);
      if (this.forma) this.forma.addEventListener('change', osvezi);
      window.addEventListener('pageshow', osvezi);

      // Pre slanja forme ubacimo gotovu sliku u skriveno polje.
      //
      // ⚠ Slika se kači SAMO ako su polja stvarno popunjena. Dok su prazna,
      // pregled crta primer, pa bi se uz porudžbinu zakačila fotografija sa
      // slovom koje niko nije ukucao. Tačno to se desilo porudžbini #16019
      // (12.10.2026): u njoj „Inicijal" je prazan, a na slici stoji „Н".
      if (this.forma) {
        this.forma.addEventListener('submit', (e) => {
          if (!this.proveri()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          this.spremiSliku();
        }, true);

        const dugme = this.forma.querySelector('[type="submit"], [data-oi-atc-button]');
        if (dugme) {
          dugme.addEventListener('click', (e) => {
            if (!this.proveri()) {
              e.preventDefault();
              e.stopImmediatePropagation();
              const prazno = [this.poljeInicijal, this.poljePrezime]
                .filter((p) => p && !(p.value || '').trim())[0];
              if (prazno) prazno.focus();
              return;
            }
            this.spremiSliku();
          }, true);
        }
      }

      this.proveri();
    }

    // Seli platno u prvu sliku galerije. Lupa se na tom slajdu gasi, jer bi
    // uvećavala fotografiju ispod, a ne ono što kupac vidi.
    uGaleriju() {
      const okvir = this.querySelector('[data-oi-ot-okvir]');
      if (!okvir) return;
      const slajd = document.querySelector('.oi-pdp__media .oi-media__slide[data-oi-slide="0"]');

      if (!slajd) {
        okvir.classList.add('oi-ot__platno-okvir--ovde');
        return;
      }

      slajd.removeAttribute('data-oi-lupa');
      slajd.removeAttribute('data-oi-lupa-src');
      okvir.classList.add('oi-ot__platno-okvir--galerija');
      slajd.appendChild(okvir);
    }

    async pripremi() {
      const uzmi = (src) =>
        new Promise((ok) => {
          const i = new Image();
          i.crossOrigin = 'anonymous';
          i.onload = () => ok(i);
          i.onerror = () => ok(null);
          i.src = src;
        });

      const [podloga, ornament, strelice, porodica, porodicaCir, izujse] = await Promise.all([
        uzmi(this.dataset.podloga),
        uzmi(this.dataset.ornament),
        uzmi(this.dataset.strelice),
        uzmi(this.dataset.porodica),
        uzmi(this.dataset.porodicaCir),
        uzmi(this.dataset.izujse),
      ]);
      this.slike = { podloga, ornament, strelice, porodica, porodicaCir, izujse };

      // Font mora da bude učitan PRE prvog crtanja, inače se prvi prikaz
      // nacrta zamenskim pa se promeni kad pravi stigne.
      //
      // Učitava se SAMO font za pismo koje je sada izabrano. Drugi se dovlači
      // tek ako kupac promeni pismo bez osvežavanja strane. Promena pisma
      // inače menja varijantu i osvežava stranu, pa se to retko dešava.
      this.fontUrl = {
        OimanoGourmand: this.dataset.font,
        OimanoGaramond: this.dataset.fontCir,
        OimanoRubik: this.dataset.fontRubik,
      };
      this.fontStanje = {};
      await this.ucitajFont(this.dizajn.pisma[this.pismo()].font);
    }

    // Dovlači jedan font i pamti da je gotov. Isti font se nikad ne traži dvaput.
    async ucitajFont(ime) {
      if (!ime || !this.fontUrl) return;
      if (this.fontStanje[ime]) return this.fontStanje[ime];
      const url = this.fontUrl[ime];
      if (!url) return;
      this.fontStanje[ime] = (async () => {
        try {
          const f = new FontFace(ime, 'url(' + url + ')');
          await f.load();
          document.fonts.add(f);
        } catch (e) {
          /* bez fonta crtamo zamenskim, pregled i dalje radi */
        }
      })();
      return this.fontStanje[ime];
    }

    // Brojač slova pored naziva polja.
    prebroj() {
      if (!this.brojac || !this.poljePrezime) return;
      const najvise = Number(this.poljePrezime.getAttribute('maxlength')) || 0;
      if (!najvise) return;
      const koliko = this.poljePrezime.value.length;
      this.brojac.textContent = koliko + '/' + najvise;
      this.brojac.classList.toggle('je-puno', koliko >= najvise);
    }

    /**
     * Da li su obavezna polja STVARNO popunjena.
     *
     * ⚠ Zašto ne verujemo `required` atributu: pregledač ga zadovoljava i
     * samim razmakom. Kupac ukuca razmak, pregledač pusti dalje, naš kod i
     * Shopify razmak skrate, i porudžbina stigne sa praznim poljem dok na
     * slici stoji slovo iz primera. Tako je prošla porudžbina #16019
     * (12.10.2026). Zato proveravamo sami, sa skraćivanjem.
     *
     * Dok nije u redu, dugme za korpu je zaključano, a ispod polja stoji
     * rečenica koja kaže zašto.
     */
    proveri() {
      const polja = [this.poljeInicijal, this.poljePrezime].filter(Boolean);
      let uRedu = true;

      polja.forEach((p) => {
        const prazno = !(p.value || '').trim();
        p.setCustomValidity(prazno ? 'Upišite tekst koji ide na otirač.' : '');
        if (prazno) uRedu = false;
      });

      const napomena = this.querySelector('[data-oi-ot-mora]');
      if (napomena) napomena.hidden = uRedu;

      if (this.forma) {
        const dugme = this.forma.querySelector('[type="submit"][name="add"], [type="submit"], [data-oi-atc-button]');
        if (dugme) {
          dugme.disabled = !uRedu;
          dugme.setAttribute('aria-disabled', String(!uRedu));
        }
      }

      return uRedu;
    }

    // Ključ je vezan za proizvod, da se tekst sa jednog otirača ne prelije
    // na drugi. `sessionStorage` traje samo dok je kartica otvorena.
    kljuc() {
      return 'oi-otirac-' + (this.dataset.varijante || '').slice(0, 14);
    }

    zapamti() {
      try {
        sessionStorage.setItem(this.kljuc(), JSON.stringify({
          i: this.poljeInicijal ? this.poljeInicijal.value : '',
          p: this.poljePrezime ? this.poljePrezime.value : '',
        }));
      } catch (e) {
        /* ako privatni režim ne da da se pamti, radi i bez toga */
      }
    }

    vrati() {
      try {
        const z = JSON.parse(sessionStorage.getItem(this.kljuc()) || '{}');
        if (this.poljeInicijal && !this.poljeInicijal.value && z.i) this.poljeInicijal.value = z.i;
        if (this.poljePrezime && !this.poljePrezime.value && z.p) this.poljePrezime.value = z.p;
      } catch (e) {
        /* isto, bez pamćenja i dalje sve radi */
      }
    }

    // Koje je pismo izabrano? Čitamo iz izabrane varijante.
    pismo() {
      if (!this.varijante) {
        this.varijante = {};
        String(this.dataset.varijante || '').split('|').forEach((par) => {
          const i = par.indexOf(':');
          if (i > 0) this.varijante[par.slice(0, i)] = par.slice(i + 1);
        });
      }
      const polje = this.forma && this.forma.querySelector('[name="id"]');
      const naziv = polje ? this.varijante[String(polje.value)] || '' : '';
      // „ćirilica", „cirilica", „ћирилица" — hvatamo sve tri varijante zapisa.
      if (!this.dizajn.pisma.cirilica) return 'latinica';
      return /[ćc]irilica|ирилица/.test(naziv) ? 'cirilica' : 'latinica';
    }

    // Nacrt (7087×4724) → fotografija (960×960) → isečak → platno.
    uRavan(x, y) {
      const P = this.dizajn.polje;
      const N = this.dizajn.nacrt;
      const fx = P.left + (x / N.w) * P.w;
      const fy = P.top + (y / N.h) * P.h;
      return {
        x: SCENA.x + (fx - ISECAK.x) * SCENA.k,
        y: SCENA.y + (fy - ISECAK.y) * SCENA.k,
      };
    }

    razmera() {
      return (this.dizajn.polje.w / this.dizajn.nacrt.w) * SCENA.k;
    }

    crtajSloj(slika, m) {
      if (!slika) return;
      const a = this.uRavan(m.left, m.top);
      this.ctx.drawImage(slika, a.x, a.y, m.w * this.razmera(), m.h * this.razmera());
    }

    // Tekst po luku. Poluprečnik 0 znači ravan tekst.
    crtajTekst(tekst, m, poluprecnik, imeFonta) {
      if (!tekst) return;
      const c = this.ctx;
      const r = this.razmera();

      let velicina = m.velicina * r;
      c.font = velicina + 'px ' + imeFonta + ', serif';
      // Razmak izmedju slova iz nacrta. Stariji pregledaci ga ne podrzavaju,
      // pa tekst bude neznatno uzi, ali se i dalje iscrta.
      if ('letterSpacing' in c) c.letterSpacing = ((m.razmak || 0) * r) + 'px';
      const maxSirina = m.maxSirina * r;
      const sirina = c.measureText(tekst).width;
      // Automatsko smanjivanje, isto kao `autoscale` kod TeeInBlue.
      if (sirina > maxSirina) {
        velicina = velicina * (maxSirina / sirina);
        c.font = velicina + 'px ' + imeFonta + ', serif';
        if ('letterSpacing' in c) c.letterSpacing = ((m.razmak || 0) * r * (maxSirina / sirina)) + 'px';
      }

      c.fillStyle = '#000';
      c.textAlign = 'center';
      c.textBaseline = 'middle';

      const sredina = this.uRavan(m.cx, m.cy);

      if (!poluprecnik || tekst.length < 2) {
        c.fillText(tekst, sredina.x, sredina.y);
        return;
      }

      const R = poluprecnik * r;
      const ukupno = c.measureText(tekst).width;
      let ugao = -ukupno / (2 * R);

      c.save();
      c.translate(sredina.x, sredina.y + R);
      for (const znak of tekst) {
        const w = c.measureText(znak).width;
        ugao += w / (2 * R);
        c.save();
        c.rotate(ugao);
        c.translate(0, -R);
        c.fillText(znak, 0, 0);
        c.restore();
        ugao += w / (2 * R);
      }
      c.restore();
    }

    crtaj() {
      const c = this.ctx;
      if (!c) return;
      c.clearRect(0, 0, PLATNO, PLATNO);
      c.fillStyle = '#fff';
      c.fillRect(0, 0, PLATNO, PLATNO);

      const kljuc = this.pismo();
      const p = this.dizajn.pisma[kljuc];

      // Kupac je promenio pismo bez osvežavanja strane, a taj font još nije
      // dovučen. Crtamo odmah zamenskim, pa ponovo čim pravi stigne.
      if (p.font && this.fontStanje && !this.fontStanje[p.font]) {
        this.ucitajFont(p.font).then(() => this.crtaj());
      }

      if (this.slike.podloga) {
        // Iz prostora 960 u prave piksele fajla, kakav god da je.
        const s = (this.slike.podloga.naturalWidth || MOKAP) / MOKAP;
        c.drawImage(
          this.slike.podloga,
          ISECAK.x * s, ISECAK.y * s, ISECAK.w * s, ISECAK.h * s,
          SCENA.x, SCENA.y, SCENA.w, SCENA.h
        );
      }
      // Slojevi zajednički za dizajn, pa oni koji zavise od pisma.
      this.dizajn.slojevi.concat(p.slojevi).forEach((m) => this.crtajSloj(this.slike[m.slika], m));

      // Dok je polje prazno, na otiraču stoji primer iz nagoveštaja, da kupac
      // odmah vidi kako gotova stvar izgleda. Samo polje ostaje prazno, pa se
      // primer ne može slučajno poručiti: „Dodajte u korpu" traži pravi unos.
      const procitaj = (el) => {
        if (!el) return '';
        const upisano = (el.value || '').trim().toUpperCase();
        return upisano || (el.placeholder || '').trim().toUpperCase();
      };
      const unos = {
        inicijal: procitaj(this.poljeInicijal),
        prezime: procitaj(this.poljePrezime),
      };

      p.tekstovi.forEach((m) => {
        let tekst = unos[m.polje] || '';
        // Na ćiriličnoj varijanti crtamo ćirilicom, pa makar kupac kucao
        // latinicom. Ako je već kucao ćirilicom, prepis je ne dira.
        if (kljuc === 'cirilica') tekst = uCirilicu(tekst);
        const luk = m.polje === 'inicijal' ? this.lukInicijal : this.lukPrezime;
        this.crtajTekst(tekst, m, luk, p.font);
      });
    }

    // Prebacuje nacrtano u fajl i ubacuje ga u skriveno polje forme.
    spremiSliku() {
      if (!this.poljeSlika || !this.platno) return;
      try {
        // ⚠ JPG, ne PNG. Mereno 10.10.2026 na pravoj strani: isto platno daje
        // 2.439 KB kao PNG, a 376 KB kao JPG. Ta slika se salje Shopify-ju pri
        // svakom „Dodajte u korpu", pa je kupac na telefonu cekao da se otpremi
        // 2,4 MB i dugme se vrtelo nekoliko sekundi.
        //
        // Providnost ne treba, jer se platno pre crtanja oboji belom bojom.
        // Kvalitet 0.85 je dovoljan: ova slika sluzi kao slicica u korpi i u
        // potvrdnom mejlu, i kao podsetnik za izradu, ne kao fajl za stampu.
        const podaci = this.platno.toDataURL('image/jpeg', 0.85);
        const delovi = podaci.split(',');
        const bin = atob(delovi[1]);
        const niz = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i += 1) niz[i] = bin.charCodeAt(i);
        const fajl = new File([niz], 'otirac.jpg', { type: 'image/jpeg' });
        const prenos = new DataTransfer();
        prenos.items.add(fajl);
        this.poljeSlika.files = prenos.files;
      } catch (e) {
        // Ako ne uspe, porudžbina i dalje nosi upisani tekst, samo bez sličice.
      }
    }
  }

  if (!customElements.get('oimano-otirac')) {
    customElements.define('oimano-otirac', OimanoOtirac);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-packs"] && !Shopify.designMode) return;
  try {
    class OimanoPacks extends HTMLElement {
    connectedCallback() {
      this.radios = [...this.querySelectorAll('[data-oi-pack]')];
      if (!this.radios.length) return;

      this.form = this.closest('form');
      this.qtyInput = this.form?.querySelector('[data-oi-quantity]');
      this.currentEl = this.querySelector('[data-oi-packs-current]');

      this.radios.forEach((r) => {
        r.addEventListener('change', () => this.apply(r));
      });

      const checked = this.radios.find((r) => r.checked) || this.radios[0];
      this.apply(checked, true);
    }

    apply(radio, tiho) {
      if (!radio) return;
      radio.checked = true;

      this.radios.forEach((r) => {
        r.closest('.oi-pack')?.classList.toggle('is-selected', r === radio);
      });

      if (this.qtyInput) this.qtyInput.value = radio.dataset.qty;
      if (this.currentEl) this.currentEl.textContent = radio.dataset.label || '';

      // Javi dugmetu novu ukupnu cenu.
      this.form?.dispatchEvent(
        new CustomEvent('oi:total-change', {
          bubbles: true,
          detail: {
            quantity: Number(radio.dataset.qty),
            totalMoney: radio.dataset.totalMoney,
            savingMoney: radio.dataset.savingMoney,
            silent: !!tiho,
          },
        })
      );
    }
  }

  if (!customElements.get('oimano-packs')) {
    customElements.define('oimano-packs', OimanoPacks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-pills"] && !Shopify.designMode) return;
  try {
    class OimanoPills extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.oi-pill')];
      if (this.items.length < 2) return;
      if (!this.classList.contains('oi-pills--mob-slider')) return;

      this.interval = Number(this.dataset.interval) || 2000;
      this.postujSmanjeno = this.dataset.respectReduced === 'true';
      this.index = 0;

      this.mqMobile = window.matchMedia('(max-width: 749px)');
      this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.sync = () => this.uskladi();
      this.mqMobile.addEventListener('change', this.sync);
      this.mqReduce.addEventListener('change', this.sync);

      this.onVisibility = () => {
        if (document.hidden) this.zaustavi();
        else if (this.classList.contains('is-rotating')) this.pokreni();
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      this.uskladi();
    }

    uskladi() {
      var manjeKretanja = this.mqReduce.matches;
      var rotiraj = this.mqMobile.matches && !(manjeKretanja && this.postujSmanjeno);

      this.classList.toggle('is-rotating', rotiraj);
      this.classList.toggle('is-instant', rotiraj && manjeKretanja);
      this.setAttribute('data-oi-state', rotiraj ? 'rotira' : 'mirno');

      this.zaustavi();

      if (rotiraj) {
        this.prikazi(0);
        this.pokreni();
      } else {
        this.items.forEach((el) => el.classList.remove('is-active'));
      }
    }

    pokreni() {
      this.zaustavi();
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.items.length;
        this.prikazi(this.index);
      }, this.interval);
    }

    zaustavi() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    prikazi(i) {
      this.index = i;
      this.items.forEach((el, n) => el.classList.toggle('is-active', n === i));
    }

    disconnectedCallback() {
      this.zaustavi();
      this.mqMobile?.removeEventListener('change', this.sync);
      this.mqReduce?.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  }

  if (!customElements.get('oimano-pills')) {
    customElements.define('oimano-pills', OimanoPills);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oimano-varijante"] && !Shopify.designMode) return;
  try {
    class OimanoVarijante extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      const podaci = this.querySelector('[data-oi-var-podaci]');
      if (!podaci) return;
      try {
        this.varijante = JSON.parse(podaci.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(this.varijante) || !this.varijante.length) return;

      this.polje = this.form.querySelector('[data-oi-variant-id]') || this.form.querySelector('[name="id"]');
      if (!this.polje) return;

      this.imaPakovanja = !!this.form.querySelector('[data-oi-pack]');
      this.pocetnaCena = Number(this.getAttribute('data-pocetna-cena'));

      this.dugme = this.form.querySelector('[data-oi-atc-button]');
      this.natpis = this.form.querySelector('[data-oi-atc-label]');
      if (this.natpis) this.natpisPocetni = this.natpis.innerHTML;

      this.oznaciNedostupne();
      this.addEventListener('change', () => this.promena());
    }

    grupe() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-oi-var-grupa]'));
    }

    izabrano() {
      return this.grupe().map(function (g) {
        const r = g.querySelector('[data-oi-var-radio]:checked');
        return r ? r.value : null;
      });
    }

    nadji(izbor) {
      return this.varijante.find(function (v) {
        if (!Array.isArray(v.opcije) || v.opcije.length !== izbor.length) return false;
        return v.opcije.every(function (o, i) {
          return o === izbor[i];
        });
      });
    }

    /* Precrta vrednost za koju ne postoji nijedna dostupna varijanta.
       Kod jedne opcije je to tacan sud; kod vise opcija je to gruba
       naznaka, a pravu rec ima provera pri samoj promeni. */
    oznaciNedostupne() {
      const sve = this.varijante;
      this.grupe().forEach(function (g, gi) {
        const radiji = g.querySelectorAll('[data-oi-var-radio]');
        Array.prototype.forEach.call(radiji, function (r) {
          const ima = sve.some(function (v) {
            return v.dostupna && v.opcije[gi] === r.value;
          });
          const pilula = r.nextElementSibling;
          if (pilula) pilula.classList.toggle('oi-var__pilula--nema', !ima);
        });
      });
    }

    promena() {
      const izbor = this.izabrano();

      this.grupe().forEach(function (g, i) {
        const natpis = g.querySelector('[data-oi-var-izbor]');
        if (natpis && izbor[i]) natpis.textContent = izbor[i];
      });

      const v = this.nadji(izbor);
      if (!v) return;

      // Razlicita cena uz pakovanja: popusti se racunaju na serveru, pa
      // stranicu prepustamo serveru umesto da lazemo iznose.
      if (this.imaPakovanja && Number(v.cena) !== this.pocetnaCena) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.location.href = u.toString();
        return;
      }

      // Svojstvo za slanje forme, atribut za TeeInBlue-ov MutationObserver.
      this.polje.value = String(v.id);
      this.polje.setAttribute('value', String(v.id));
      if (v.dostupna) {
        this.polje.removeAttribute('disabled');
      } else {
        this.polje.setAttribute('disabled', '');
      }

      const cena = this.form.querySelector('[data-oi-price-now]');
      if (cena && v.cena_tekst) cena.textContent = v.cena_tekst;

      if (!this.imaPakovanja) {
        const cenaDugme = this.form.querySelector('[data-oi-atc-price]');
        if (cenaDugme && v.cena_tekst) cenaDugme.innerHTML = '&nbsp;&middot; ' + v.cena_tekst;
      }

      if (this.dugme) this.dugme.disabled = !v.dostupna;
      if (this.natpis) {
        if (v.dostupna) {
          if (this.natpisPocetni != null && this.natpis.textContent.trim() === 'Rasprodato') {
            this.natpis.innerHTML = this.natpisPocetni;
          }
        } else {
          this.natpis.textContent = 'Rasprodato';
        }
      }

      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());

      // Dodatni znak za TeeInBlue, pored `change` koji ionako ispliva do forme.
      document.dispatchEvent(new Event('shopify-event-variant-changed'));
    }
  }

  if (!customElements.get('oimano-varijante')) {
    customElements.define('oimano-varijante', OimanoVarijante);
  }
  } catch(e) { console.error(e); }
})();

})();
